__turbopack_context__.v({
  "bottomTooltipArrow": "PopupArrow-module__VCUSvq__bottomTooltipArrow",
  "tooltipArrow": "PopupArrow-module__VCUSvq__tooltipArrow",
  "topTooltipArrow": "PopupArrow-module__VCUSvq__topTooltipArrow",
});
